import {
  GET_AUDIT_RECORDS_REQUEST,
  GET_AUDIT_RECORDS_SUCCESS,
  GET_AUDIT_RECORDS_ERROR,
  GET_AUDIT_DETAILS_REQUEST,
  GET_AUDIT_DETAILS_SUCCESS,
  GET_AUDIT_DETAILS_ERROR,
  GET_AUDIT_ASSETS_REQUEST,
  GET_AUDIT_ASSETS_SUCCESS,
  GET_AUDIT_ASSETS_ERROR,
  GET_ASSET_AUDITS_REQUEST,
  GET_ASSET_AUDITS_SUCCESS,
  GET_ASSET_AUDITS_ERROR,
  RECONCILE_AUDIT_REQUEST,
  RECONCILE_AUDIT_SUCCESS,
  RECONCILE_AUDIT_ERROR,
  DELETE_AUDIT_REQUEST,
  DELETE_AUDIT_SUCCESS,
  DELETE_AUDIT_ERROR,
} from './auditActionTypes';

const initialState = {
  isLoading: false,
  isSuccess: false,
  payload: {},
  message: '',
  count: 0,
  auditRecords: [],
  auditRecord: {},
  auditRecordItems: [],
  scannedAssets: [],
};

export default function auditReducer(state = initialState, action) {
  const { type, payload, isLoading, message } = action;

  switch (type) {
    case GET_AUDIT_RECORDS_REQUEST:
      return { ...state, isLoading };
    case GET_AUDIT_RECORDS_SUCCESS:
      return { ...state, isLoading, auditRecords: payload.data, count: payload.count };
    case GET_AUDIT_RECORDS_ERROR:
      return { ...state, isLoading, message };
    case GET_AUDIT_DETAILS_REQUEST:
      return { ...state, isLoading };
    case GET_AUDIT_DETAILS_SUCCESS:
      return {
        ...state,
        isLoading,
        auditRecordItems: payload.data,
        auditRecord: payload.audit_record,
        count: payload.count,
      };
    case GET_AUDIT_DETAILS_ERROR:
      return { ...state, isLoading, message };
    case GET_AUDIT_ASSETS_REQUEST:
      return { ...state, isLoading };
    case GET_AUDIT_ASSETS_SUCCESS:
      return { ...state, isLoading, scannedAssets: payload.data, count: payload.count };
    case GET_AUDIT_ASSETS_ERROR:
      return { ...state, isLoading, message };
    case GET_ASSET_AUDITS_REQUEST:
      return { ...state, isLoading };
    case GET_ASSET_AUDITS_SUCCESS:
      return { ...state, isLoading, scannedAssets: payload.data, count: payload.data.count };
    case GET_ASSET_AUDITS_ERROR:
      return { ...state, isLoading, message };
    case RECONCILE_AUDIT_REQUEST:
      return { ...state, isLoading };
    case RECONCILE_AUDIT_SUCCESS:
      return { ...state, isLoading, message };
    case RECONCILE_AUDIT_ERROR:
      return { ...state, isLoading, message };
    case DELETE_AUDIT_REQUEST:
      return { ...state, isLoading };
    case DELETE_AUDIT_SUCCESS:
      return { ...state, isLoading, message };
    case DELETE_AUDIT_ERROR:
      return { ...state, isLoading, message };
    default: {
      return state;
    }
  }
}
